export default "__VITE_ASSET__CSieqe9B__"